import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent, TooltipArrow } from '@/components/ui/tooltip';
import { Trash2 } from 'lucide-react';
import { CustomTooltipArrow } from '../Icons/CustomTooltipArrow';

interface DeleteButtonProps {
  label: string; // Tooltip text
  onClick: () => void; // Click handler
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({ label, onClick }) => {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={500}>
        <TooltipTrigger className="group outline-none" tabIndex={-1}>
          <button aria-label={label} onClick={onClick}>
            <Trash2 className="stroke-secondary-grey-02 hover:stroke-deep-blue" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          className="bg-secondary-grey-06 rounded-2xl border-none px-4 py-1 text-xs leading-6 text-white"
          sideOffset={15}
        >
          {label}
          <CustomTooltipArrow />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
